import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { Modal } from 'bootstrap';

import videojs from 'video.js';

import { Tutorial, TutorialSection } from 'src/app/interfaces/tutorial';
import { StateService } from 'src/app/services/state.service';

import { TutorialsService } from 'src/app/services/tutorials.service';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tutorials-tablet',
  templateUrl: './tutorials-tablet.component.html',
  styleUrls: ['./tutorials-tablet.component.scss'],
})
export class TutorialsTabletComponent implements OnInit {
  @ViewChild('downloadFrame', { static: true }) downloadContainer?: ElementRef;
  sections: TutorialSection[] = [];
  tutorials: Tutorial[] = [];
  selectedSection?: TutorialSection;
  selectedSubsection: any;
  searchText: string = '';
  player: any;

  showSections: boolean = true;
  showSubsections: boolean = false;
  showTutorial: boolean = false;

  constructor(
    private tutorialService: TutorialsService,
    private stateService: StateService
  ) {}

  ngOnInit() {
    this.getTutorials();
  }

  getTutorials(params: string = '') {
    this.tutorialService.getAllSections(params).subscribe({
      next: (sections: TutorialSection[]) => {
        // Assign the retrieved sections to the local variable
        this.sections = sections;

        // Calculate the tutorial count for each section
        this.sections.forEach((s: TutorialSection) => {
          if (s.tutorials) {
            s.tutorialCount = s.tutorials?.length;
          } else if (s.subsection) {
            s.tutorialCount = 0;
            s.subsection.forEach((subsection: any) => {
              if (subsection.tutorials) {
                s.tutorialCount += subsection.tutorials.length;
              }
            });
          } else {
            s.tutorialCount = 0;
          }

          // Remove subsections without tutorials
          if (s.subsection) {
            s.subsection.forEach((subsection: any) => {
              if (!subsection.tutorials) {
                s.subsection = s.subsection.filter(
                  (sub: any) => subsection.name !== sub.name
                );
              }
            });
          }

          // Update the selected section if it exists in the retrieved sections
          if (this.selectedSection) {
            this.selectedSection = this.sections.filter(
              (s: TutorialSection) => {
                return s.id == this.selectedSection!.id;
              }
            )[0];

            // Select the updated section
            this.selectSection(this.selectedSection);
          }

          if (this.showTutorial) {
            this.selectedSubsection = this.selectedSection?.subsection.filter(
              (sub: any) => {
                return sub.name == this.selectedSubsection!.name;
              }
            )[0];

            this.selectSubsection(this.selectedSubsection);
          }
        });

        // Filter out sections without tutorials
        this.sections = this.sections.filter((s: TutorialSection) => {
          return s.tutorialCount! > 0;
        });
      },
    });
  }

  selectSection(section: TutorialSection) {
    this.selectedSection = section;
    this.showSections = false;

    if (section.tutorials) {
      this.tutorials = section.tutorials;
    } else if (section.subsection && !this.showTutorial) {
      this.showSubsections = true;
    }
  }

  selectSubsection(subsection: any) {
    this.selectedSubsection = subsection;
    this.tutorials = subsection.tutorials;
    this.showSubsections = false;
    this.showTutorial = true;
  }

  async openVideoModal(tutorialId: number) {
    this.stateService.selectedTabletTutorialId = tutorialId;

    const modal = new Modal('#videoModal');
    this.stateService.openModal = modal;

    modal.show();

    // const modal = await this.modalCtrl.create({
    //   component: ExecutionVideoModalComponent,
    //   componentProps: {
    //     tutorialId,
    //   },
    // });
    // modal.present();
  }

  manageTutorial(tutorial: Tutorial) {
    switch (tutorial.format) {
      case 'SHORT_VIDEO':
        this.openVideoModal(tutorial.id!);
        break;

      case 'LONG_VIDEO':
        this.openVideoModal(tutorial.id!);
        break;

      default:
        this.downloadPDF(tutorial);
        break;
    }
  }

  downloadPDF(tutorial: Tutorial) {
    const url = `${environment.apiUrl}/tutorial/${tutorial.id!}`;
    this.downloadContainer!.nativeElement.src = url;

    this.showDownloadAlert();

    // this.routineService.getExerciseVideo(tutorial.id!).subscribe({
    //   next: (response: any) => {
    //

    //   },
    //   error: () => {},
    // });
  }

  async showDownloadAlert() {}

  unselectSection() {
    this.showSections = true;
    this.tutorials = [];
    this.selectedSection = undefined;
    this.showSubsections = false;
    this.showTutorial = false;
  }

  filterTutorials() {
    if (this.searchText.length > 0) {
      this.getTutorials(`name=${this.searchText}`);
    } else {
      this.getTutorials();
    }
  }
}
